import showErrorToast from '@/lib/helpers/showToastError.tsx'
import { api } from '@/lib/api-client.ts'
import { ProjectStagesUsersT } from '@/components/common/menu/lib/types/projectStagesUsers.ts'

export const currStageUsersQuery = (projectStageId: string | undefined | number) => ({
  queryKey: ['currStageUsersQuery', { projectStageId }],
  queryFn: () => getCurrStageUsers(projectStageId),
  staleTime: 1000 * 60,
})
export const getCurrStageUsers = async (projectStageId: string | undefined | number) => {
  // console.log(`getCurrStageUsers`, projectStageId)
  if (!projectStageId) {
    showErrorToast(`project id missing!`)
    return []
  }
  const res = await api.get(`/project_stages/${projectStageId}/users`)
  const users: ProjectStagesUsersT = res.data['hydra:member']
  // console.log(`users`, users)
  return users
}
